<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="hv-sub-list-item">
    <div class="hv-daten-nebengebaeude-gebaudeArt-container">
      <ng-template *ngTemplateOutlet="gebaeudeArtTemplate"></ng-template>
    </div>
    <div class="hv-daten-nebengebaeude-flaeche-container">
      <ng-template *ngTemplateOutlet="flaecheQmTemplate"></ng-template>
    </div>
    <div class="hv-daten-nebengebaeude-bauweise-container">
      <ng-template *ngTemplateOutlet="bauweiseTemplate"></ng-template>
    </div>
    <div class="hv-daten-nebengebaeude-variante-container">
      <ng-template *ngTemplateOutlet="varianteTemplate"></ng-template>
    </div>
  </div>
  <ng-template #gebaeudeArtTemplate>
    <div>
      <div>
        <div class="input">
          <app-label [control]="gebaeudeArt" class="input__label" [for]="'nebengebaeude-gebaeudeArt-' + index">Art:</app-label>
          <mat-form-field>
            <mat-select [id]="'nebengebaeude-gebaeudeArt-' + index" formControlName="gebaeudeArt">
              <mat-option *ngFor="let gebaeudeArt of getGebaeudeArten() | keyvalue" [value]="gebaeudeArt.key">{{ gebaeudeArt.value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="gebaeudeArt.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #flaecheQmTemplate>
    <div class="input">
      <app-label [control]="flaecheQm" class="input__label" [for]="'nebengebaeude-flaecheQm-' + index">Fläche in m²</app-label>
      <mat-form-field>
        <input matInput [id]="'nebengebaeude-flaecheQm-' + index" formControlName="flaecheQm" placeholder="m²">
        <mat-error *ngIf="flaecheQm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        <mat-error *ngIf="flaecheQm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
        <mat-error *ngIf="!flaecheQm.hasError('pattern') && flaecheQm.hasError('min')">{{ 'MINVALUE' | translate:{'value': flaecheQm.errors.min.min} }}</mat-error>
        <mat-error *ngIf="!flaecheQm.hasError('pattern') && flaecheQm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': flaecheQm.errors.max.max} }}</mat-error>
      </mat-form-field>
    </div>
  </ng-template>
  <ng-template #bauweiseTemplate>
    <div class="input_radio">
      <app-label [control]="bauweise" [for]="'nebengebaeude-bauweise-' + index">Bauweise</app-label>
      <mat-radio-group [id]="'nebengebaeude-bauweise-' + index" formControlName="bauweise">
        <mat-radio-button value="3">Massiv hart</mat-radio-button>
        <mat-radio-button value="1">Holzbauweise</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="bauweise.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #varianteTemplate>
    <div class="input">
      <div class="text_info">
        <app-label [control]="variante" class="input__label" [for]="'nebengebaeude-variante-' + index">Variante:</app-label>
      </div>
      <mat-form-field>
        <mat-select [id]="'nebengebaeude-variante-' + index" formControlName="variante">
          <mat-option *ngFor="let variante of getVarianten() | keyvalue" [value]="variante.key">{{ variante.value }}</mat-option>
        </mat-select>
        <mat-error *ngIf="variante.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </mat-form-field>
    </div>
  </ng-template>
</form>
